// extracted by mini-css-extract-plugin
export default {"component":"ColorItem_component__P2hhU","active":"ColorItem_active__gN0-m"};